<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         width="40" height="40" viewBox="0 0 38 38" style="enable-background:new 0 0 38 38;" xml:space="preserve">
        <g>
	        <g>
		        <path class="svg-outline-color" d="M19,38C8.52,38,0,29.48,0,19S8.52,0,19,0s19,8.52,19,19S29.48,38,19,38z M19,1C9.08,1,1,9.07,1,19
			        c0,9.92,8.08,18,18,18s18-8.08,18-18C37,9.07,28.92,1,19,1z"/>
	        </g>
            <path class="svg-secondary-color" d="M22.04,21.11c1.51-0.98,2.5-2.68,2.5-4.61c0-3.04-2.46-5.5-5.5-5.5s-5.5,2.46-5.5,5.5
		            c0,1.92,0.98,3.6,2.46,4.58c-2.49,1-4.35,3.22-4.87,5.92h1.54c0.68-2.87,3.25-5,6.32-5s5.64,2.13,6.32,5h1.54
		            C26.35,24.32,24.5,22.12,22.04,21.11z M15.05,16.5c0-2.21,1.79-4,4-4c2.21,0,4,1.79,4,4c0,2.21-1.79,4-4,4
		            C16.84,20.5,15.05,18.71,15.05,16.5z"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "accountIcon"
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/accountIcon.vue